import classNames from 'classnames';

import { Link } from '../link';
import * as styles from './InlineLink.css';
import type { LeafMarkProps } from './Text.types';

export function InlineLinkElement(props: LeafMarkProps) {
  const { mark, children, attributes, className, isClientSideNavigation, onClick } = props;

  const { attrs } = mark;

  if (isClientSideNavigation) {
    return (
      <button
        type="button"
        className={classNames(styles.actionButton, className, styles.linkElement)}
        onClick={onClick}
        {...(attrs?.hasUnderline && { 'data-underline': true })}
        {...attributes}
      >
        {children}
      </button>
    );
  }

  return (
    <Link
      href={attrs?.href || '#'}
      // internal_link={attrs?.internal_link}
      open_in_new_tab={attrs?.target === '_blank'}
      className={classNames(className, styles.linkElement)}
      hasUnderline={attrs?.hasUnderline}
      {...attributes}
    >
      {children}
    </Link>
  );
}
